import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { Loading } from "../utils/components/Loading";
import { Box } from "@mui/material";
import axios from "axios";

export default function AuthProvider() {
    const { fetchMe, accessToken, refreshToken, isLoading } = useAuthStore();
    const [loading, setLoading] = useState(true)

    const checkAuth = async () => {
        try {
            setLoading(true)
            await fetchMe();
        } catch (e) {
            console.log(e)
        }
        finally{
            setLoading(false)
        }
    }
    
    useEffect(() => {
        checkAuth()
    }, [])
    const location = useLocation();

    if (loading || isLoading) {
        return (
            <Box width={"100%"} height={"100%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                <Loading />
            </Box>
        );
    }

    if (!accessToken || !refreshToken) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    return <Outlet />; // рендерим дочерние Route
}
